module.exports = __webpack_public_path__ + "static/img/qi.b4afc71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/qi.png
// module id = b7Qt
// module chunks = 1